<template>
  <div class="modifiers">
    <div v-for="(modifier, index) in modifiers" :key="modifier.id">
      <div
        :id="`a${modifier.id}`"
        :ref="modifier.name"
        class="requiredInfo font-size-12"
      >
        <!-- 提示语 -->
        <div class="title">
          <h3 bold class="title-name">
            {{ modifier.name }}
          </h3>
          <span :class="['title-required', { hide: modifier.min <= 0 }]">
            {{ $t('details.required') }}
          </span>
          <span v-if="modifier.min > 1" class="title-tip">
            {{
              $t('details.minSelect', { min: modifier.min, max: modifier.max })
            }}
          </span>
          <span v-else class="title-tip">
            {{
              $t('details.maxSelect', [
                modifier.type === 'SINGLE' ? 1 : modifier.max,
              ])
            }}
          </span>
        </div>
        <div class="option bg-white q-py-sm">
          <q-list>
            <template v-for="option in modifier.options">
              <q-item
                :key="option.id"
                v-ripple
                tag="label"
                class="q-px-sm q-py-none m-status"
                :class="!option.inStock ? 'disabled' : ''"
              >
                <q-item-section avatar top class="no-padding select-btn">
                  <template v-if="modifier.type === 'SINGLE'">
                    <q-radio
                      v-model="vModelArr[index]"
                      :val="option.id"
                      :disable="!option.inStock"
                    />
                  </template>
                  <!-- 多选框 -->
                  <template v-else>
                    <q-checkbox
                      v-model="vModelArr[index]"
                      :val="option.id"
                      :disable="!option.inStock"
                    />
                  </template>
                </q-item-section>
                <!-- 单选多选的 数据 -->
                <q-item-section class="textBox">
                  <q-item-label class="text-weight-bolder font-size-16">
                    <h4 style="word-break: break-word">
                      {{ option.name }}
                    </h4>
                  </q-item-label>
                  <q-item-label v-if="option.price" caption>
                    <h5>+ {{ $n(option.price, 'currency', 'id-ID') }}</h5>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  model: {
    prop: 'optParams',
    event: 'getModifier',
  },
  props: {
    optParams: {
      type: Array,
      default: () => {},
    },
    original: {
      type: Array,
      default: () => {},
    },
    historyData: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modifiers: [],
      vModelArr: [],
    };
  },
  computed: {
    modifierIdtoOptId() {
      if (Array.isArray(this.modifiers) && this.modifiers.length > 0) {
        const list = this.modifiers.reduce(
          (pre, cur) => pre.concat(cur.options),
          [],
        );
        return list.reduce((pre, cur) => {
          pre[cur.optionProductId] = cur.id;
          return pre;
        }, {});
      }
      return {};
    },
  },
  watch: {
    original: {
      handler(val) {
        if (val && val.length > 0) {
          this.modifiers = _.cloneDeep(val);
          this.vModelArr = [];
          this.modifiers.forEach((item) => {
            if (item.type === 'SINGLE') {
              if (item.value) {
                this.vModelArr.push(item.value.modifierOptionId);
              } else {
                this.vModelArr.push('');
              }
            } else if (item.value) {
              const arr = [];
              item.value.forEach((modi) => {
                arr.push(modi.modifierOptionId);
              });
              this.vModelArr.push(arr);
            } else {
              this.vModelArr.push([]);
            }
            item.options.forEach((opti) => {
              opti.params = {
                price: opti.price,
                name: opti.name,
                seqNum: opti.seqNum,
                optionProductId: opti.optionProductId,
                modifierOptionId: opti.id,
                modifierItemId: item.id,
              };
            });
          });
          this.selectDefaultModifier();
        }
      },
      immediate: true,
      deep: true,
    },
    vModelArr: {
      handler(val) {
        const isEmpty = val.every((item) => _.isEmpty(item));
        if (isEmpty) {
          this.$emit('getModifier', []);
        } else {
          const params = [];
          this.modifiers.forEach((item, index) => {
            const isArray = Array.isArray(val[index]);
            // 超出最大限制 删除上一个
            if (isArray && val[index].length > item.max) {
              val[index].splice(val[index].length - 2, 1);
            }
            if (isArray) {
              const arr = [];
              item.options.forEach((opti) => {
                if (val[index].some((str) => str === opti.id)) {
                  arr.push(opti.params);
                }
              });
              params.push(arr);
            } else if (!_.isEmpty(val[index])) {
              item.options.forEach((opti) => {
                if (opti.id === val[index]) {
                  params.push(opti.params);
                }
              });
            } else {
              params.push('');
            }
          });
          this.$emit('getModifier', params);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 根据url上的参数 modifier 的id，选中的modifier
    selectDefaultModifier() {
      const defaultData = this.$route.query.historyData || this.historyData;
      if (!defaultData) return;
      let defaultModifiers = [];
      try {
        defaultModifiers = JSON.parse(decodeURIComponent(defaultData));
        defaultModifiers = defaultModifiers.filter(Boolean);
      } catch (e) {
        defaultModifiers = [];
      }
      const _vModelArr = this.modifiers.map((it) => {
        const optProductIds = it.options.map((opIt) => opIt.optionProductId);
        const selected = _.intersection(defaultModifiers, optProductIds) || [];
        if (it.type === 'MULTIPLE') {
          if (selected.length === 0) return [];
          return [...selected.map((id) => this.modifierIdtoOptId[id])];
        }
        return this.modifierIdtoOptId[selected[0]];
      });
      this.vModelArr = _vModelArr;
    },
  },
};
</script>

<style lang="scss">
:deep(.m-status) {
  .disabled .q-checkbox__svg {
    background: #e5e7eb;
    color: red;
  }

  &.disabled {
    color: #e5e7eb;
  }
}
.modifiers {
  h3 {
    display: inline;
    font-size: 12px;
    margin-top: 0;
    margin-bottom: 0;
    line-height: 120%;
  }
  h4 {
    display: inline;
    line-height: 120%;
    font-size: 16px;
    // font-weight: bold;
  }
  h5 {
    display: inline;
    line-height: 120%;
    font-size: 12px;
  }
  .textBox {
    justify-content: flex-start !important;
    margin-top: 10px;
  }
  .requiredInfo {
    .title {
      padding: 10px 16px;
      background-color: $grayBg;
      display: grid;
      grid-template-rows: repeat(2, minmax(0, 1fr));
      grid-template-columns: repeat(2, minmax(0, 1fr));
      &-name {
        font-size: 16px;
        min-width: 300px;
      }
      &-tip {
        color: $grayFont;
        margin-top: 2px;
      }
      &-required {
        border-radius: 2px;
        color: #fff;
        padding: 2px 4px;
        background-color: $primary;
        grid-row: span 2 / span 2;
        align-self: center;
        margin-left: auto;
        &.hide {
          opacity: 0;
        }
      }
    }
    .select-btn {
      width: 36px;
      flex: auto;
      min-width: unset;
      font-size: 14px;
    }
  }
}
</style>
